import type { FC } from 'react';

import Pill from '@/common-components/Pill';
import type { StudentAccountStatus, StudentKycStatus } from '@/types/student.types';

export const KycStatusPill: FC<{ status: StudentKycStatus; accountStatus?: StudentAccountStatus }> = ({
  status,
  accountStatus,
}) => {
  // A deleted account keeps kyc.status = 'auto_approved' while its ID card and email
  // verification are gone — showing "✓ Verified" there claims something that is no longer true.
  if (accountStatus === 'deleted') return <Pill tone="neutral">— Erased</Pill>;
  if (status === 'auto_approved') {
    return <Pill tone="success">✓ Verified</Pill>;
  }
  return <Pill tone="warn">⏳ Not Submitted</Pill>;
};

export const AccountStatusPill: FC<{ status: StudentAccountStatus }> = ({ status }) => {
  if (status === 'suspended') return <Pill tone="warn">Suspended</Pill>;
  if (status === 'banned') return <Pill tone="danger">Banned</Pill>;
  if (status === 'deleted') return <Pill tone="neutral">🗑 Deleted</Pill>;
  return <Pill tone="success">Active</Pill>;
};
